var render = function render(){
  var _vm$items;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('section', {
    staticClass: "section pt-40"
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_c('recruitment-list-search', {
    staticClass: "mb-40"
  }), _c('v-row', {
    staticClass: "my-10"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('recruitment-list-sort', {
    attrs: {
      "outlined": "",
      "solo": "",
      "flat": "",
      "prepend-inner-icon": "mdi-sort"
    }
  })], 1)], 1), (_vm$items = _vm.items) !== null && _vm$items !== void 0 && _vm$items.length ? [_c('div', {
    staticClass: "recruitment-cards"
  }, _vm._l(_vm.items, function (item) {
    var _item$company, _item$company$logo, _item$company3;
    return _c('v-card', {
      key: item._id,
      staticClass: "recruitment-card",
      attrs: {
        "rounded": "lg",
        "outlined": "",
        "to": `/recruitments/${item._id}`
      }
    }, [_c('v-row', [_c('v-col', {
      staticClass: "mb-n30 mb-md-0",
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "w-100 h-100 border-md-end d-flex align-center justify-center pa-20"
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 180 / 60,
        "max-width": "180",
        "width": "180",
        "height": "60",
        "contain": "",
        "src": item === null || item === void 0 ? void 0 : (_item$company = item.company) === null || _item$company === void 0 ? void 0 : (_item$company$logo = _item$company.logo) === null || _item$company$logo === void 0 ? void 0 : _item$company$logo.url
      },
      scopedSlots: _vm._u([{
        key: "placeholder",
        fn: function () {
          var _item$company2;
          return [_c('v-layout', {
            staticClass: "h-100 text-center",
            attrs: {
              "justify-center": "",
              "align-center": ""
            }
          }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$company2 = item.company) === null || _item$company2 === void 0 ? void 0 : _item$company2.name) + " ")])];
        },
        proxy: true
      }], null, true)
    })], 1)]), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "9"
      }
    }, [_c('div', {
      staticClass: "pa-20 pt-md-20 pl-md-10 pl-lg-0"
    }, [_c('p', {
      staticClass: "page-text page-text--sm primary--text mb-4"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$company3 = item.company) === null || _item$company3 === void 0 ? void 0 : _item$company3.name))]), _c('h5', {
      staticClass: "page-text--lg font-wieght-medium mb-8 mb-lg-16"
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.subject) + " "), _c('like-btn', {
      attrs: {
        "params": {
          _recruitment: item._id,
          type: _vm.USER_LIKE_TYPES.RECRUITMENT.value
        }
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var active = _ref.active,
            toggle = _ref.toggle;
          return [_c('v-btn', {
            attrs: {
              "icon": "",
              "text": "",
              "color": active ? 'yellow darken-1' : undefined
            },
            on: {
              "!click": function ($event) {
                $event.stopPropagation();
                $event.preventDefault();
                return toggle.apply(null, arguments);
              }
            }
          }, [_c('v-icon', [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
        }
      }], null, true)
    })], 1), _c('v-chip-group', {
      staticClass: "mb-4"
    }, [_c('v-chip', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "grey-d"
      }
    }, [_c('span', {
      staticClass: "grey-6--text"
    }, [_vm._v(" " + _vm._s(item.employment.typesTexts.join(" / ")) + " ")])])], 1), _c('p', {
      staticClass: "page-text grey-6--text ellip mb-8 mb-lg-16"
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.summary))]), _c('recruitment-list-item-application', _vm._b({}, 'recruitment-list-item-application', {
      item
    }, false))], 1)])], 1)], 1);
  }), 1), _c('div', {
    staticClass: "mt-40 mt-lg-60"
  }, [_c('v-pagination', {
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    on: {
      "input": function (page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page
          })
        });
      }
    }
  })], 1)] : _c('v-layout', {
    staticClass: "page-text page-text--lg border-top pt-12 pt-lg-20",
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_vm._v(" 등록된 채용공고가 없습니다. ")])], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }